/**
 * resolveLevelColor — picks the right severityStyle palette for a
 * (agentName, fieldKey, value) tuple, so MiniRow / FieldDiff render
 * LevelBadge swatches identical to each Step's live DataTable.
 *
 * Ported from the mockup's WorkflowVersionsRedesign.jsx (lines
 * 121-140) — no semantic changes. Same call signatures, same
 * palettes.
 */
import {
  getImpactColor,
  getRiskValueColor,
  getTreatmentDecisionColor,
  getTreatmentPriorityColor,
  getFeasibilityColor,
  getRiskLevelColor,
} from '../../../utils/severityStyle';

export function resolveLevelColor(
  agentName: string | null | undefined,
  fieldKey: string,
  value: unknown,
): string | undefined {
  if (value === null || value === undefined || value === '') return undefined;

  if (agentName === 'damage_scenario_agent') {
    return getImpactColor(String(value), { scheme: 'fourTier' });
  }
  if (agentName === 'risk_assessment_agent') {
    if (fieldKey === 'risk_value') {
      return getRiskValueColor(Number(value));
    }
    if (fieldKey === 'treatment_decision') return getTreatmentDecisionColor(String(value));
    if (fieldKey === 'treatment_priority') return getTreatmentPriorityColor(value);
    if (fieldKey === 'risk_level') return getRiskLevelColor(value);
  }
  if (
    agentName === 'attack_path_feasibility_agent' &&
    fieldKey === 'attack_feasibility_rating'
  ) {
    return getFeasibilityColor(String(value));
  }
  return undefined;
}
